export default {"src":"https://assets.madeeasy.in/prod/_next/static/media/course.d9b995fc.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};